export default {
    phoneCode: '/v1/common/smscode',
    getLotteryCount: '/v1/activity/summer/add',
    lottery: '/v1/activity/summer/lottery',
    getchance: '/v1/activity/summer/getchance',
    lotteryResult: '/v1/activity/summer/result'
};